// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import StripeCustomer from "./stripe-customer.js"
import StripeDiscount from "./stripe-discount.js"
import StripePlan from "./stripe-plan.js"
import StripeSubscriptionItem from "./stripe-subscription-item.js"

const modelClassData = {
  "attributes": {
    "billing": {
      "column": {
        "default": null,
        "name": "billing",
        "null": true,
        "type": "string"
      },
      "name": "billing",
      "selected_by_default": null,
      "translated": null
    },
    "created": {
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      },
      "name": "created",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "cancel_at_period_end": {
      "column": {
        "default": null,
        "name": "cancel_at_period_end",
        "null": true,
        "type": "boolean"
      },
      "name": "cancel_at_period_end",
      "selected_by_default": null,
      "translated": null
    },
    "canceled_at": {
      "column": {
        "default": null,
        "name": "canceled_at",
        "null": true,
        "type": "datetime"
      },
      "name": "canceled_at",
      "selected_by_default": null,
      "translated": null
    },
    "current_period_end": {
      "column": {
        "default": null,
        "name": "current_period_end",
        "null": true,
        "type": "datetime"
      },
      "name": "current_period_end",
      "selected_by_default": null,
      "translated": null
    },
    "current_period_start": {
      "column": {
        "default": null,
        "name": "current_period_start",
        "null": true,
        "type": "datetime"
      },
      "name": "current_period_start",
      "selected_by_default": null,
      "translated": null
    },
    "days_until_due": {
      "column": {
        "default": null,
        "name": "days_until_due",
        "null": true,
        "type": "integer"
      },
      "name": "days_until_due",
      "selected_by_default": null,
      "translated": null
    },
    "ended_at": {
      "column": {
        "default": null,
        "name": "ended_at",
        "null": true,
        "type": "datetime"
      },
      "name": "ended_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "quantity": {
      "column": {
        "default": null,
        "name": "quantity",
        "null": true,
        "type": "integer"
      },
      "name": "quantity",
      "selected_by_default": null,
      "translated": null
    },
    "start_date": {
      "column": {
        "default": null,
        "name": "start_date",
        "null": true,
        "type": "datetime"
      },
      "name": "start_date",
      "selected_by_default": null,
      "translated": null
    },
    "status": {
      "column": {
        "default": null,
        "name": "status",
        "null": true,
        "type": "string"
      },
      "name": "status",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_customer_id": {
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_customer_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_discount_id": {
      "column": {
        "default": null,
        "name": "stripe_discount_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_discount_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "total_price": {
      "column": null,
      "name": "total_price",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "StripeSubscription",
  "collectionKey": "stripe_subscriptions",
  "collectionName": "stripe_subscriptions",
  "i18nKey": "stripe_subscription",
  "camelizedLower": "stripeSubscription",
  "name": "StripeSubscription",
  "nameDasherized": "stripe-subscription",
  "pluralName": "stripe_subscriptions",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeTaxRate",
      "collectionName": "stripe_tax_rates",
      "foreignKey": "stripe_tax_rate_id",
      "name": "default_tax_rates",
      "macro": "has_many",
      "resource_name": "StripeTaxRate",
      "through": "stripe_subscription_default_tax_rates"
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_discount",
      "macro": "belongs_to",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_discounts",
      "macro": "has_many",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeInvoiceItem",
      "collectionName": "stripe_invoice_items",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_invoice_items",
      "macro": "has_many",
      "resource_name": "StripeInvoiceItem",
      "through": null
    },
    {
      "className": "StripeInvoice",
      "collectionName": "stripe_invoices",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_invoices",
      "macro": "has_many",
      "resource_name": "StripeInvoice",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plan",
      "macro": "belongs_to",
      "resource_name": "StripePlan",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plans",
      "macro": "has_many",
      "resource_name": "StripePlan",
      "through": "stripe_subscription_items"
    },
    {
      "className": "StripeSubscriptionDefaultTaxRate",
      "collectionName": null,
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription_default_tax_rates",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripeSubscriptionItem",
      "collectionName": "stripe_subscription_items",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription_items",
      "macro": "has_many",
      "resource_name": "StripeSubscriptionItem",
      "through": null
    },
    {
      "className": "StripeSubscriptionSchedule",
      "collectionName": null,
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription_schedules",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "stripe_subscription_id",
      "name": "subscription",
      "macro": "has_one",
      "resource_name": "Subscription",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "application_fee_percent",
      "column": {
        "default": null,
        "name": "application_fee_percent",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "billing",
      "column": {
        "default": null,
        "name": "billing",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "cancel_at_period_end",
      "column": {
        "default": null,
        "name": "cancel_at_period_end",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "canceled_at",
      "column": {
        "default": null,
        "name": "canceled_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "current_period_end",
      "column": {
        "default": null,
        "name": "current_period_end",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "current_period_start",
      "column": {
        "default": null,
        "name": "current_period_start",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "days_until_due",
      "column": {
        "default": null,
        "name": "days_until_due",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "ended_at",
      "column": {
        "default": null,
        "name": "ended_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "latest_stripe_invoice_id",
      "column": {
        "default": null,
        "name": "latest_stripe_invoice_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "quantity",
      "column": {
        "default": null,
        "name": "quantity",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "start_date",
      "column": {
        "default": null,
        "name": "start_date",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "status",
      "column": {
        "default": null,
        "name": "status",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_customer_id",
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_discount_id",
      "column": {
        "default": null,
        "name": "stripe_discount_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_plan_id",
      "column": {
        "default": null,
        "name": "stripe_plan_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tax_percent",
      "column": {
        "default": null,
        "name": "tax_percent",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "trial_end",
      "column": {
        "default": null,
        "name": "trial_end",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "trial_start",
      "column": {
        "default": null,
        "name": "trial_start",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_discount",
      "macro": "belongs_to",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_discounts",
      "macro": "has_many",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plans",
      "macro": "has_many",
      "resource_name": "StripePlan",
      "through": "stripe_subscription_items"
    },
    {
      "className": "StripeSubscriptionItem",
      "collectionName": "stripe_subscription_items",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription_items",
      "macro": "has_many",
      "resource_name": "StripeSubscriptionItem",
      "through": null
    }
  ],
  "paramKey": "stripe_subscription",
  "primaryKey": "id"
}

/** Frontend model for StripeSubscription. */
export default class StripeSubscription extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  billing() {
    return this.readAttributeUnderscore("billing")
  }

  /** @returns {boolean} */
  hasBilling() {
    const value = this.billing()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  created() {
    return this.readAttributeUnderscore("created")
  }

  /** @returns {boolean} */
  hasCreated() {
    const value = this.created()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  cancelAtPeriodEnd() {
    return this.readAttributeUnderscore("cancel_at_period_end")
  }

  /** @returns {boolean} */
  hasCancelAtPeriodEnd() {
    const value = this.cancelAtPeriodEnd()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  canceledAt() {
    return this.readAttributeUnderscore("canceled_at")
  }

  /** @returns {boolean} */
  hasCanceledAt() {
    const value = this.canceledAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  currentPeriodEnd() {
    return this.readAttributeUnderscore("current_period_end")
  }

  /** @returns {boolean} */
  hasCurrentPeriodEnd() {
    const value = this.currentPeriodEnd()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  currentPeriodStart() {
    return this.readAttributeUnderscore("current_period_start")
  }

  /** @returns {boolean} */
  hasCurrentPeriodStart() {
    const value = this.currentPeriodStart()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  daysUntilDue() {
    return this.readAttributeUnderscore("days_until_due")
  }

  /** @returns {boolean} */
  hasDaysUntilDue() {
    const value = this.daysUntilDue()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  endedAt() {
    return this.readAttributeUnderscore("ended_at")
  }

  /** @returns {boolean} */
  hasEndedAt() {
    const value = this.endedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  quantity() {
    return this.readAttributeUnderscore("quantity")
  }

  /** @returns {boolean} */
  hasQuantity() {
    const value = this.quantity()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  startDate() {
    return this.readAttributeUnderscore("start_date")
  }

  /** @returns {boolean} */
  hasStartDate() {
    const value = this.startDate()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  status() {
    return this.readAttributeUnderscore("status")
  }

  /** @returns {boolean} */
  hasStatus() {
    const value = this.status()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeCustomerId() {
    return this.readAttributeUnderscore("stripe_customer_id")
  }

  /** @returns {boolean} */
  hasStripeCustomerId() {
    const value = this.stripeCustomerId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeDiscountId() {
    return this.readAttributeUnderscore("stripe_discount_id")
  }

  /** @returns {boolean} */
  hasStripeDiscountId() {
    const value = this.stripeDiscountId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  totalPrice() {
    return this.readAttributeUnderscore("total_price")
  }

  /** @returns {boolean} */
  hasTotalPrice() {
    const value = this.totalPrice()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static clientSecret(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "client_secret",
        collectionName: "stripe_subscriptions",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static updateSubscription(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "update_subscription",
        collectionName: "stripe_subscriptions",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  cancel(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "cancel",
        primaryKey: this.primaryKey(),
        collectionName: "stripe_subscriptions",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  reactivate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "reactivate",
        primaryKey: this.primaryKey(),
        collectionName: "stripe_subscriptions",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./stripe-customer.js").default | null} */
  stripeCustomer() {
    return this._readBelongsToReflection({modelClass: StripeCustomer, reflectionName: "stripe_customer"})
  }

  /** @returns {Promise<import("./stripe-customer.js").default | null>} */
  loadStripeCustomer() {
    if (!("stripeCustomerId" in this)) throw new Error("Foreign key method wasn't defined: stripeCustomerId")

    const id = this.stripeCustomerId()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_customer",
        model: this,
        modelClass: StripeCustomer
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-customer.js").default | null>} */
  ensureStripeCustomerLoaded() {
    return this.ensureAssociationLoaded("stripe_customer")
  }

  /** @returns {import("./stripe-discount.js").default | null} */
  stripeDiscount() {
    return this._readBelongsToReflection({modelClass: StripeDiscount, reflectionName: "stripe_discount"})
  }

  /** @returns {Promise<import("./stripe-discount.js").default | null>} */
  loadStripeDiscount() {
    if (!("stripeDiscountId" in this)) throw new Error("Foreign key method wasn't defined: stripeDiscountId")

    const id = this.stripeDiscountId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_discount",
        model: this,
        modelClass: StripeDiscount
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-discount.js").default | null>} */
  ensureStripeDiscountLoaded() {
    return this.ensureAssociationLoaded("stripe_discount")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./stripe-discount.js").default>} */
  stripeDiscounts() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const ransack = {}

    ransack["stripe_subscription_id_eq"] = this.stripeId()

    return new Collection(
      {
        reflectionName: "stripe_discounts",
        model: this,
        modelClass: StripeDiscount
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-discount.js").default>>} */
  loadStripeDiscounts() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const ransack = {}

    ransack["stripe_subscription_id_eq"] = this.stripeId()

    return this._loadHasManyReflection(
      {
        reflectionName: "stripe_discounts",
        model: this,
        modelClass: StripeDiscount
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-discount.js").default>>} */
  ensureStripeDiscountsLoaded() {
    return this.ensureAssociationLoaded("stripe_discounts")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./stripe-plan.js").default>} */
  stripePlans() {
    return new Collection(
      {
        reflectionName: "stripe_plans",
        model: this,
        modelClass: StripePlan
      },
      {
        params: {
          through: {
            model: "StripeSubscription",
            id: this.primaryKey(),
            reflection: "stripe_plans"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./stripe-plan.js").default>>} */
  loadStripePlans() {
    return this._loadHasManyReflection(
      {
        reflectionName: "stripe_plans",
        model: this,
        modelClass: StripePlan
      },
      {
        params: {
          through: {
            model: "StripeSubscription",
            id: this.primaryKey(),
            reflection: "stripe_plans"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./stripe-plan.js").default>>} */
  ensureStripePlansLoaded() {
    return this.ensureAssociationLoaded("stripe_plans")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./stripe-subscription-item.js").default>} */
  stripeSubscriptionItems() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const ransack = {}

    ransack["stripe_subscription_id_eq"] = this.stripeId()

    return new Collection(
      {
        reflectionName: "stripe_subscription_items",
        model: this,
        modelClass: StripeSubscriptionItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-subscription-item.js").default>>} */
  loadStripeSubscriptionItems() {
    if (!("stripeId" in this)) throw new Error("No such primary key method: stripeId")

    const ransack = {}

    ransack["stripe_subscription_id_eq"] = this.stripeId()

    return this._loadHasManyReflection(
      {
        reflectionName: "stripe_subscription_items",
        model: this,
        modelClass: StripeSubscriptionItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./stripe-subscription-item.js").default>>} */
  ensureStripeSubscriptionItemsLoaded() {
    return this.ensureAssociationLoaded("stripe_subscription_items")
  }
}
